import storage from './storage'

class AuthService {
    constructor() {

    }

    isUserAuthenticated() {
        if (typeof window !== 'undefined') {
            // We are in the browser
            var token = this.getAuthToken();
            if (token) {
                return true;
            }
        }
        return false;
    }

    cleanAuthData() {
        storage.deleteAuthData();
    }

    getAuthToken() {

        if (!localStorage) {
            return null;
        }
        if (storage.getExpireDate()) {
            if (Date.now() > parseInt(storage.getExpireDate())) {
                this.cleanAuthData(); // localStorage.removeItem("authData");
                return null;
            }
        } else {
            return null;
        }

        return storage.getToken();
    }

    setAuthData(token) {
        var expireDate = Date.now() + 8 * 3600 * 1000;
        storage.saveToken(token);
        storage.setExpireDate(expireDate);
    }

}

const authService = new AuthService();

export default authService;